import { encrypt, decrypt } from './Crypto';
import dayjs from 'dayjs';
import MessageAlert from './MessageAlert';
export default MessageAlert;

export const DEPLOY_TYPE = process.env.REACT_APP_DEPLOY_TYPE;
export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
export const DOMAIN_URL = process.env.REACT_APP_DOMAIN_URL;
export const HOST_URL = process.env.REACT_APP_HOST_URL;
export const STORE_URL = process.env.REACT_APP_STORE_URL;
export const KAKAO_CLIENT_KEY = process.env.REACT_APP_KAKAO_CLIENT_KEY;
export const NAVER_CLIENT_KEY = process.env.REACT_APP_NAVER_CLIENT_KEY;
export const GOOGLE_CLIENT_KEY = process.env.REACT_APP_GOOGLE_CLIENT_KEY;
export const FACEBOOK_CLIENT_KEY = process.env.REACT_APP_FACEBOOK_CLIENT_KEY;
export const APPLE_CLIENT_KEY = process.env.REACT_APP_APPLE_CLIENT_KEY;
export const SOCIAL_CALLBACK_URL = process.env.REACT_APP_SOCIAL_CALLBACK_URL;
export const PAYMENT_URL = process.env.REACT_APP_PAYMENT_URL;
export const PAYMENT_PC_URL = process.env.REACT_APP_PAYMENT_PC_URL;
export const PAYMENT_STORE_ID = process.env.REACT_APP_PAYMENT_STORE_ID;
export const POINT_STORE_ID = process.env.REACT_APP_POINT_STORE_ID;

/**
 * 쿠키찾기
 * --
 */
export const getCookie = (name, options = null) => {
  const value = window.document.cookie.match(
    '(^|;) ?' + name + '=([^;]*)(;|$)'
  );

  let decryptValue = null;
  if (value) {
    if (name === 'JM_COFFEE_ACCESS_TOKEN') {
      decryptValue = value[2];
    } else {
      decryptValue = decrypt(value[2]);
    }
  }

  return decryptValue;
};

/**
 * 쿠키저장
 * --
 */
export const setCookie = (name, value, domain, callback = false) => {
  let encryptValue = null;
  if (name === 'JM_COFFEE_ACCESS_TOKEN') {
    encryptValue = value;
  } else {
    encryptValue = encrypt(value);
  }
  const subDomain = domain ? `;domain=.${domain}` : '';
  window.document.cookie = `${name}=${encryptValue}; path=/ ${subDomain}`;
  if (callback) callback();
};

/**
 * 쿠키삭제
 * --
 */
export const removeCookie = (name, value, time) => {
  let encryptValue = null;
  if (name === 'JM_COFFEE_ACCESS_TOKEN') {
    encryptValue = value;
  } else {
    encryptValue = encrypt(value);
  }

  const t = new Date();
  time = time === '' ? '' : '; expires=' + t.setTime(t.getTime() + time);

  document.cookie =
    name +
    '=' +
    encryptValue +
    '; path=/' +
    (time ? '; expires=' + t.toGMTString() : '');
};

/**
 * 쿠키삭제
 * --
 */
export const deleteCookie = (name, { path, domain }) => {
  if (getCookie(name)) {
    window.document.cookie =
      name +
      '=' +
      (path ? ';path=' + path : '') +
      (domain ? ';domain=' + domain : '') +
      ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
};

/**
 * 로컬스토리지 찾기
 * --
 */
export const getStorage = (name) => {
  const itemStr = localStorage.getItem(name);

  if (!itemStr) return null;

  const item = JSON.parse(decrypt(itemStr));

  if (item.expiration && Date.now() > item.expiration) {
    localStorage.removeItem(name);
    return null;
  }

  return item.value;
};

/**
 * 로컬스토리지 저장
 * --
 */
export const setStorage = (name, value, expiration) => {
  const item = {
    value: value,
    expiration: expiration ?? null,
  };

  const encryptItem = encrypt(JSON.stringify(item));

  localStorage.setItem(name, encryptItem);
};

/**
 * 로컬스토리지 제거
 * --
 */
export const deleteStorage = (name) => {
  localStorage.removeItem(name);
};

/**
 * API파라미터 Replace함수
 * --
 */
export const parameterToPath = (path, params = {}) => {
  const keys = Object.keys(params);
  let newStr = '';
  for (let key of keys) {
    newStr = path.replace(`:${key}`, params[key]);
  }
  return newStr;
};

/**
 * 금액 포맷터
 * --
 * @param {*} v
 * @param {*} unit
 * @returns
 */
export const stringToMoneyFormat = (v = 0, unit = '') => {
  // 음수 여부를 확인합니다.
  const vv = v || 0;
  const isNegative = vv < 0;
  const absoluteValue = Math.abs(vv);

  const value = String(absoluteValue).split('').reverse().join('');
  const valueLength = value.length;
  let result = '';
  for (let ii in value) {
    result += String(value[ii]);
    if ((parseInt(ii) + 1) % 3 === 0 && parseInt(ii) < valueLength - 1) {
      result += ',';
    }
  }
  // 음수인 경우 '-' 기호를 추가합니다.
  return `${isNegative ? '-' : ''}${result
    .split('')
    .reverse()
    .join('')}${unit}`;
};

/**
 * 할인 금액 계산
 * --
 * @param {number} originPrice
 * @param {number} sale
 * @param {string} type (R 또는 W)
 * @return {number}
 */
export const discountedPrice = (
  originPrice,
  discount,
  type = 'R',
  policies
) => {
  if (typeof originPrice !== 'number' || typeof discount !== 'number') {
    throw new Error('상품 가격과 할인은 숫자로 입력되어야 합니다.');
  }
  let limitPrice = 0;
  let discountedPrice;
  if (type === 'R') {
    // 할인이 %로 주어진 경우

    if (policies.length > 0) {
      originPrice * (discount / 100) !== policies[0]?.discount_price
        ? (limitPrice =
            originPrice * (discount / 100) - policies[0]?.discount_price)
        : (limitPrice = 0);
    }
    discountedPrice = originPrice - originPrice * (discount / 100) + limitPrice;

    // discountedPrice <= policyPrice ?? (discountedPrice = policyPrice);
  } else if (type === 'W') {
    // 할인이 원으로 주어진 경우
    if (policies.length > 0) {
      originPrice - discount !== policies[0]?.discount_price
        ? (limitPrice = originPrice - discount - policies[0]?.discount_price)
        : (limitPrice = 0);
    }
    discountedPrice = originPrice - discount + limitPrice;
    // discountedPrice <= policyPrice ?? (discountedPrice = policyPrice);
  } else {
    // 잘못된 할인 형식일 경우 원래 가격을 반환
    discountedPrice = originPrice;
  }
  console.log(discountedPrice);

  // 소수점 둘째 자리까지 반올림하여 반환
  return Math.round(discountedPrice * 100) / 100;
};

/**
 * 랜덤 인증번호 생성
 * --
 * @param {number} length
 * @returns
 */
export const generateAlphanumericCode = (length = 6) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
};

/**
 * 기준일을 기준으로 날짜 계산
 * --
 * @param {number} unixTimestamp
 * @param {number} days
 * @param {string} returnType
 * @returns
 */
export const calculateFutureDate = (unixTimestamp, days) => {
  const secondsInADay = 86400; // 하루의 초 (24 * 60 * 60)

  // daysToAdd가 양수면 더하고, 음수면 빼는 방식으로 계산
  const futureTimestamp = unixTimestamp + secondsInADay * days;

  // 미래의 유닉스 타임스탬프를 Date 객체로 변환하여 반환
  return futureTimestamp; // 밀리초로 변환
};

/**
 * 나이 계산
 * --
 * @param {Date} birthday
 * @returns
 */
export const calculateAge = (birthday) => {
  const today = new Date(); // 현재 날짜와 시간을 가져옴
  const birth = new Date(birthday); // 생년월일을 날짜 객체로 생성

  // 만나이 계산
  let age = today.getFullYear() - birth.getFullYear();

  // 생일이 지나지 않았다면 -1
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  const koreanAge = age + 1;

  return {
    age: age,
    koreanAge: koreanAge,
  };
};

/**
 * 특정 기간에 대한 시작일과 종료일을 반환하는 함수
 * --
 * @param {number} days - 기준이 되는 일 수 (0: 오늘, 7: 1주일, 30: 1개월)
 * @returns {[string, string]} - 시작일과 종료일 ([YYYY-MM-DD HH:mm:ss, YYYY-MM-DD HH:mm:ss])
 */
export const getDateRange = (days) => {
  const now = new Date(); // 현재 시간

  // 날짜를 YYYY-MM-DD HH:mm:ss 형식으로 포맷팅하는 함수
  const formatDate = (date) => {
    const pad = (n) => (n < 10 ? `0${n}` : n);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
  };

  let startDate, endDate;

  // 종료일: 오늘의 끝
  endDate = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    23,
    59,
    59
  );

  // 시작일 계산
  if (days === 0) {
    // 오늘
    startDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
  } else if (days > 0) {
    // 특정 기간 이전
    startDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - (days - 1),
      0,
      0,
      0
    );
  } else {
    throw new Error(
      'Invalid days parameter. It must be 0 or a positive number.'
    );
  }

  return [formatDate(startDate), formatDate(endDate)];
};

/**
 * 트리구조 정제
 * --
 * @param {array} treeData
 * @param {string} key
 * @param {string} parentsKey
 * @param {string} sortKey
 * @returns
 */
export const mappingTreeData = (
  treeData = [],
  key = 'product_category_id',
  parentsKey = 'parents_id',
  sortKey = null // 정렬 기준 키
) => {
  // 최종 트리형 데이터 저장
  let mappingData = [];

  // 최상위 부모 데이터 정제
  const topData = treeData.filter((_item) => !_item[parentsKey]);

  // 정렬 함수
  const sortData = (data) => {
    if (!sortKey) return data;
    return data.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  };

  // 재귀적으로 부모-자식 관계 매핑
  const mapping = (parents, k = null) => {
    const children = treeData.filter(
      (_item) => parents[key] === _item[parentsKey]
    );

    return {
      ...parents,
      key: !k ? `${parents[key]}` : k + `-${parents[key]}`,
      children: sortData(
        children.map((child) =>
          mapping(child, !k ? `${parents[key]}` : k + `-${parents[key]}`)
        )
      ), // 자식들도 정렬 후 재귀적으로 매핑
    };
  };

  // 최상위 부모 데이터를 순회하며 트리 구조 생성
  mappingData = sortData(topData).map((_item) => mapping(_item, null));

  return mappingData;
};

/**
 * 할인/적립금액 계산
 * --
 * @param {object} policy
 * @param {number} price
 * @returns {object}
 */
export const calculateDiscount = (price, policy) => {
  if (!policy)
    return {
      discount: 0,
      reserve: 0,
    };

  /**
   *
   * @param {number} rate 할인율
   * @param {string} type 할인 타입
   * @param {number} standard 기준 금액
   * @param {number} max 최대 할인금
   * @returns
   */
  const cal = (rate, type, standard = price, max = price) => {
    let discountPrice = 0;

    if (type === 'W') {
      // 고정 금액 할인
      discountPrice = Math.min(rate, max);
    } else if (type === 'R') {
      // 비율 할인
      const discount = (standard * rate) / 100;
      discountPrice = Math.min(discount, max);
    }

    return Math.min(discountPrice, standard);
  };

  const discountPrice = cal(
    policy.discount_rate,
    policy.discount_type,
    price,
    policy.max_discount_price
  );
  const reservePrice = cal(
    policy.reserve_rate,
    policy.reserve_type,
    policy.reserve_type === 'W' ? price : price - discountPrice
  );

  return {
    discount: discountPrice,
    reserve: reservePrice,
  };
};

/**
 * NOTE 우선순위
 * 상품(개별)혜택 < 그룹상품(묶음) 혜택 < 프로모션혜택 < 쿠폰혜택
 * 적용 정책 추출
 * --
 * @param {array} policies
 * @param {number} price
 * @param {array} promotion
 * @returns {object | null}
 */
export const extractApplicationPolicy = (policies, price, promotion = []) => {
  // 정책 우선 순위 매핑
  const priorityMap = {
    GROUP: 1,
    GENERAL: 2,
    PROMOTION: 3,
  };

  // 정책이 없을경우 리턴
  if (!policies || policies.length === 0) {
    return null;
  }

  // 프로모션 데이터가 있을 경우 진행중인 프로모션만 추출
  let progressPromotion = [];
  if (promotion.length) {
    const today = dayjs().unix();
    // const start = today.startOf('day').unix();
    // const end = today.endOf('day').unix();
    progressPromotion = promotion.filter(
      (pr) => pr.promotion_start_date <= today && pr.promotion_end_date >= today
    );
  }

  // 쿠폰 타입인 정책 필터
  const filterPolicy = policies.filter(
    (policy) => policy.policy_type !== 'COUPON' && policy.is_enable !== 'N'
  );

  // 각 타입별 가장 큰 할인 정책 찾기
  const maxDiscountByType = filterPolicy.reduce((acc, policy) => {
    // 할인금액 계산
    const { discount, reserve } = calculateDiscount(price, policy);
    const currentMaxPolicy = acc[policy.policy_type];

    // 현재 같은 타입의 정책과 할인 금액을 비교하여 할인 금액이 큰 정책 반환
    if (
      !currentMaxPolicy ||
      discount > calculateDiscount(price, currentMaxPolicy).discount
    ) {
      // 타입이 프로모션인 경우 진행중인 프로모션인지 체크
      if (policy.policy_type === 'PROMOTION') {
        const isProgress = progressPromotion.some(
          (pr) => pr.promotion_id === policy.promotion_id
        );
        // 진행중인 프로모션 정책이 아닐경우 리턴
        if (!isProgress) return acc;
      }

      // 최대 할인금과 비교하여 최대할인금액을 초과하였을 경우 할인 비율 초기화
      const discountRate = (discount / price) * 100;
      const originRate = policy['discount_rate'];
      const applyRate = originRate > discountRate ? discountRate : originRate;

      acc[policy.policy_type] = {
        ...policy,
        apply_discount_rate: Math.round(applyRate),
        discount_price: discount,
        reserve_price: reserve,
      };
    }

    return acc;
  }, {});
  // 타입별 최대 할인 정책을 배열로 변환
  const filteredPolicies = Object.values(maxDiscountByType);

  // 우선 순위에 따라 정렬 후 가장 높은 우선 순위의 정책 반환
  filteredPolicies.sort(
    (a, b) => priorityMap[b.policy_type] - priorityMap[a.policy_type]
  );
  return filteredPolicies[0] ?? null; // 가장 높은 우선 순위의 정책
};

/**
 * 트리형 데이터 평탄화
 * --
 * @param {array} treeData - 트리 형태의 카테고리 데이터
 * @param {string} childrenKey
 * @returns {array}
 */
export const flattenTreeData = (treeData = [], childrenKey = 'children') => {
  let flatList = [];

  treeData.forEach((category) => {
    const { [childrenKey]: children = [], ...rest } = category;

    // 현재 노드를 추가
    flatList.push(rest);

    // 자식 노드를 재귀적으로 처리
    if (children.length > 0) {
      flatList = flatList.concat(flattenTreeData(children, childrenKey));
    }
  });

  return flatList;
};

/**-------------------------
 * 빈값체크
 * -------------------------
 */
export const isNull = (data) => {
  // const type = typeof data;

  if (
    !data ||
    data === '' ||
    data === null ||
    data === undefined ||
    data === 'undefined' ||
    data === 'NONE' ||
    data.length < 1 ||
    Object.keys(data).length < 1
  ) {
    return true;
  } else {
    return false;
  }
};

/**
 * 쿼리스트링 추출
 * --
 * @param {object} params
 * @returns
 */
export const jsonToQueryString = (params = {}) => {
  // cno는 필수 파라미터 - 기본값
  const queryString = Object.entries(params)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join('&');

  // 쿼리 문자열 반환 (params가 없는 경우 빈 문자열 반환)
  return queryString ? `?${queryString}` : '';
};

/**
 * 팝업
 * --
 */
export const openPopup = (
  path,
  options = 'width=500, height=700, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no',
  name = 'popupChk'
) => {
  const port = DEPLOY_TYPE === 'local' ? ':3000' : '';
  const protocol = window.location.protocol;
  const sub =
    DEPLOY_TYPE === 'development'
      ? 'jm-coffee.'
      : DEPLOY_TYPE === 'local'
      ? ''
      : 'mall.';

  const popupUrl = `${protocol}//${sub}${DOMAIN_URL}${port}/#${path}`;

  const popup = window.open(popupUrl, name, options);

  if (popup) {
    popup.focus();

    return;
  } else {
    window.alert('팝업 차단을 해제해주세요.');
    return;
  }
};

/**
 * 문자열 자르기 함수
 * --
 * @param {string} str
 * @param {number} limit
 * @param {string} replaceText
 * @returns
 */
export const strCut = (str, limit = 20, replaceText = '...') =>
  str && str.length > limit ? `${str.slice(0, limit - 1)}${replaceText}` : str;

/**
 * 쿠폰 할인/적립금액 계산
 * --
 * @param {number} price 상품 결제 금액 (상품 금액 * 수량)
 * @param {object} policy 쿠폰 정책 policy_coupon
 * @returns {object}
 */
export const calculateCoupon = (price, policy) => {
  if (!policy)
    return {
      discount: 0,
      reserve: 0,
    };

  const {
    discount_rate,
    reserve_rate,
    reserve_type,
    max_discount_price,
    voucher_type,
  } = policy;

  let discountPrice = 0;
  switch (voucher_type) {
    case 'AMOUNT_DISCOUNT': // 금액 할인권
      const amountDiscount = Math.min(discount_rate, max_discount_price);
      discountPrice = Math.min(amountDiscount, price);
      break;
    case 'PERCENT_DISCOUNT': // 금액 할인권
      const discount = (price * discount_rate) / 100;
      const percentDiscount = Math.min(discount, max_discount_price);
      discountPrice = Math.min(percentDiscount, price);
      break;
    case 'EXCHANGE': // 교환권
      discountPrice = price;
      break;
    default:
      discountPrice = 0;
      break;
  }

  let reservePrice = 0;
  switch (reserve_type) {
    case 'R':
      const remainingPrice = price - discountPrice;
      reservePrice = (remainingPrice * reserve_rate) / 100;
      break;
    case 'W':
      reservePrice = reserve_rate;
      break;
    default:
      reservePrice = 0;
      break;
  }

  return {
    discount: discountPrice,
    reserve: reservePrice,
  };
};

/**
 * 공급가액, 세액, 면세금액 계산
 * --
 * @param {number} price
 * @param {number} rate
 * @param {string} type TAXABLE(과세) | EXEMPT(면세) | ZERO_RATED(영세)
 * @returns {object} { supply_price: 공급가액, tax_amount: 세액, tax_free_amount: 면세금액 }
 */
export const calculateTax = (price, rate = 10, type = 'TAXABLE') => {
  let supply_price = 0,
    tax_amount = 0,
    tax_free_amount = 0;

  const taxType = type.toLocaleUpperCase();

  switch (taxType) {
    case 'EXEMPT': // 면세
      supply_price = price;
      tax_amount = 0; // 면세는 세액이 없음
      tax_free_amount = price;
      break;
    case 'ZERO_RATED': // 영세
      supply_price = price;
      tax_amount = 0; // 세율이 0%이므로 세액이 없음
      tax_free_amount = 0; // 면세 금액 없음
      break;
    case 'TAXABLE': // 과세
    default:
      supply_price = Math.round(price / (1 + rate / 100)); // 공급가액 계산
      tax_amount = Math.round(price - supply_price); // 세액 계산
      tax_free_amount = 0; // 면세 금액 없음
      break;
  }

  return {
    supply_price, // 공급가액
    tax_amount, // 세액
    tax_free_amount, // 면세금액
  };
};

/**
 * 최상위 데이터 반환
 * --
 * @param {array} data 데이터
 * @param {number} target 최상위 데이터를 찾을 타켓 id
 * @param {string} parentsKey 부모 키값
 * @param {string} childKey 자식 키값
 * @param {string} type 데이터 형태 tree | flat
 * @param {string} childrenKey Tree 형식의 데이터일 경우 자식 요소 배열이 들어있는 키값
 */
export const findGetRootData = (
  data,
  target,
  parentsKey = 'parents_id',
  childKey = 'product_category_id',
  type = 'tree',
  childrenKey = 'children'
) => {
  // 데이터 타입
  const dataType = type.toLocaleUpperCase();

  // 트리형태 데이터 찾기
  function findRootInTree(tree, id) {
    const stack = [...tree];

    while (stack.length > 0) {
      const node = stack.pop(); // 스택에서 노드를 하나 꺼냄

      // 현재 노드가 타겟 ID인 경우
      if (node[childKey] === id) {
        // 부모가 존재하면 부모 ID로 탐색
        if (node[parentsKey]) {
          return findRootInTree(tree, node[parentsKey]);
        }
        // 부모가 없으면 최상위 노드
        return node[childKey];
      }

      // 자식 노드가 있는 경우 스택에 추가 (childrenKey를 동적으로 처리)
      if (node[childrenKey] && node[childrenKey].length > 0) {
        stack.push(...node[childrenKey]);
      }
    }

    for (const node of tree) {
      if (node[childKey] === id) {
        return node[parentsKey]
          ? findRootInTree(tree, node[parentsKey])
          : node[childKey];
      }
    }
    return null; // id가 트리에 없는 경우
  }

  // 플랫형태 데이터 찾기
  function findRootInFlat(flat, id) {
    const map = new Map(flat.map((item) => [item[childKey], item[parentsKey]]));

    while (map.has(id)) {
      const parentId = map.get(id);
      if (!parentId) return id; // 최상위 카테고리 도달
      id = parentId;
    }
    return null; // id가 데이터에 없는 경우
  }

  let rootId = null;
  switch (dataType) {
    case 'TREE':
      rootId = findRootInTree(data, target);
      break;
    case 'FLAT':
      rootId = findRootInFlat(data, target);
      break;
    default:
      break;
  }

  if (!rootId) return null;

  const rootData = data.find((d) => d[childKey] === rootId);
  return rootData;
};

/**
 * NOTE 우선순위
 * 프로모션 > 브랜드 > 상품 > 카테고리
 * 적용 수수료 추출
 * --
 * @param {array} commission { type: 수수료 타입, commission_rate: 수수료율 }
 * @returns {object | null} { type: 수수료 타입, commission_rate: 수수료율, commission_type: 수수료 부과 타입 }
 */
export const extractApplicationCommission = (
  commission = [],
  key = 'policy_type'
) => {
  const defaultCommission = {
    type: 'CATEGORY',
    commission_rate: 0, // 수수료율
    commission_type: 'R', // 수수료 타입 (R | W)
  };

  // 수수료 정책이 없을 경우
  if (!commission.length) return defaultCommission;

  // 정책 우선 순위 매핑
  const priorityMap = {
    COUPON: 1,
    PROMOTION: 2,
    BRAND: 3,
    GENERAL: 4,
    CATEGORY: 5,
  };

  // 수수료율이 0원인값 제거
  const filterCommission = commission.filter((com) => com.commission_rate > 0);

  if (!filterCommission.length) return defaultCommission;

  // 우선 순위에 따라 정렬 후 가장 높은 우선 순위의 수수료율 반환
  filterCommission.sort((a, b) => {
    const priorityDiff = priorityMap[a[key]] - priorityMap[b[key]];

    if (priorityDiff !== 0) {
      return priorityDiff; // 우선순위에 따라 정렬
    }

    // 동일한 우선순위에서는 수수료율이 높은 순으로 정렬
    return b.commission_rate - a.commission_rate;
  });

  return filterCommission[0] ?? defaultCommission;
};

/**
 * 결제 에정일
 * --
 * @param {Date | number} date
 * @param {string} cycle
 * @return {number}
 */
export const getPaymentDueDate = (date, cycle, minus = 0) => {
  const splitCycle = cycle.split('-');

  const cycleNum = Number(splitCycle[0]);

  let unit = '';
  switch (splitCycle[1]) {
    case 'W':
      unit = 'week';
      break;
    case 'M':
      unit = 'month';
      break;
    default:
      unit = 'week';
      break;
  }

  const standardDate = typeof date === 'number' ? dayjs.unix(date) : date;

  return dayjs(standardDate)
    .add(cycleNum, unit)
    .subtract(minus, 'day')
    .startOf('day')
    .unix();
};

/**
 * 포인트 분배
 * --
 * @param {number[]} amounts
 * @param {number} totalPoints
 * @returns
 */
export const distributePointByRatio = (amounts, totalPoints) => {
  const totalAmount = amounts.reduce((sum, amount) => sum + amount, 0); // 총 금액 계산

  if (totalAmount === 0) {
    return amounts.map(() => 0);
  }

  // 각 항목의 포인트 계산 (소수점 포함)
  const pointsWithDecimals = amounts.map(
    (amount) => (amount / totalAmount) * totalPoints
  );

  // 소수점 제거 및 정수로 변환
  const roundedPoints = pointsWithDecimals.map(Math.floor);

  // 정수로 변환 후 남은 포인트 계산
  const distributedPoints = roundedPoints.reduce(
    (sum, points) => sum + points,
    0
  );
  let remainingPoints = totalPoints - distributedPoints;

  // 남은 포인트를 항목에 분배 (잔여 포인트를 하나씩 추가)
  const finalPoints = [...roundedPoints];
  for (let i = 0; remainingPoints > 0; i = (i + 1) % amounts.length) {
    finalPoints[i]++;
    remainingPoints--;
  }

  return finalPoints;
};

/**
 * 렌탈 월 결제 금액 계산
 * --
 * @param {string} price 렌탈 상품 금액 (원금 + 옵션금)
 * @param {object} options 선택 렌탈 옵션
 */
export const calculateRentalMonthlyPayment = (price, options) => {
  if (!options) return price;

  // 렌탈 옵션 Flat 형식으로 변환
  const flattenedOption = { ...options };
  // mandatory_usage_date 값을 최상위로 이동
  flattenedOption['mandatory_usage_date'] = {
    ...flattenedOption.contract_date.mandatory_usage_date,
  };

  let contractDate = 1, // 계약기간
    monthlyAdditional = 0, // 월 추가금
    totalAdditional = 0, // 상품 추가금
    additionalCost = 0; // 추가금

  const calculatePrice = (variable, type, amount) => {
    switch (type) {
      case 'MINUS':
        return variable - amount;
      case 'PLUS':
      case 'ADD':
        return variable + amount;
      default:
        return variable;
    }
  };

  Object.entries(flattenedOption).forEach(([key, value]) => {
    const { option_type, option_value, option_price } = value;

    // 계약기간
    if (key === 'contract_date') {
      contractDate = option_value;
    }

    // 추가비용
    if (key === 'additional_cost') {
      return (additionalCost += option_price);
    }

    const splitType = option_type.split('_');
    switch (splitType[1]) {
      case 'MONTH':
        monthlyAdditional = calculatePrice(
          monthlyAdditional,
          splitType[0],
          option_price
        );
        break;
      case 'TOTAL':
        totalAdditional = calculatePrice(
          totalAdditional,
          splitType[0],
          option_price
        );
        break;
      default:
        break;
    }
  });

  // 렌탈 상품 총합 금액
  const totalRentalPrice = price + totalAdditional;

  // 렌탈 상품 월 결제 금액
  const monthlyPayment = Math.floor(totalRentalPrice / contractDate);

  // 최종 렌탈 월 결제 금액
  return monthlyPayment + monthlyAdditional;
};

/**
 * 옵션 합산 금액 계산
 * --
 * @param {array | null} product_option
 * @returns
 */
export const calculateTotalOptionPrice = (product_option) => {
  if (!product_option || !Array.isArray(product_option)) return 0;

  return product_option.reduce((optionAcc, optionCur) => {
    const { option } = optionCur;

    // option이 없거나 배열이 아니면 기본값 반환
    if (!option || !Array.isArray(option)) return optionAcc;

    const optionPriceSum = option.reduce((childAcc, childCur) => {
      return childAcc + (childCur.option_price || 0);
    }, 0);

    return optionAcc + optionPriceSum;
  }, 0);
};

/**
 * 모바일 체크
 * --
 */
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|JmWebViewAgent|Opera Mini/i.test(
    navigator.userAgent
  );
};

/**
 * 메타태그 추출
 * --
 * @param {string} htmlString
 * @returns {object}
 */
export const parseMetaTagString = (htmlString) => {
  // 입력값이 없거나 문자열이 아니면 빈 배열 반환
  if (!htmlString || typeof htmlString !== 'string') {
    return [];
  }

  // 1. DOMParser를 사용해 문자열을 실제 HTML 문서처럼 파싱합니다.
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');

  // 2. 파싱된 문서에서 모든 <meta> 태그를 선택합니다.
  const metaElements = doc.querySelectorAll('meta');

  // 3. 각 meta 태그의 속성들을 추출하여 객체로 만들고, 배열에 담아 반환합니다.
  const tags = Array.from(metaElements).map((element) => {
    const tagObject = {};
    for (const attr of element.attributes) {
      tagObject[attr.name] = attr.value;
    }
    return tagObject;
  });

  return tags;
};

/**
 * 메타 태그 객체 배열을 HTML 문자열로 변환
 * --
 * @param {Array<Object> | Object} tagsInput - [{property: 'og:type', ...}, ...] 형태의 객체 배열 또는 단일 객체
 * @returns {string} - "<meta...><meta...>" 형태의 문자열
 */
export const generateMetaTagString = (tagsInput) => {
  // 1. 입력값이 유효한 객체/배열이 아니면 빈 문자열 반환 (null 체크 강화)
  if (!tagsInput || typeof tagsInput !== 'object') {
    return '';
  }

  /**
   * HTML 특수문자를 이스케이프 처리합니다.
   * @param {string} str - 이스케이프할 문자열
   * @returns {string} - 이스케이프된 문자열
   */
  const escapeHtml = (str) => {
    // null 또는 undefined는 빈 문자열로 처리
    if (str == null) return '';
    return String(str).replace(/[&<>"']/g, (match) => {
      switch (match) {
        case '&':
          return '&amp;';
        case '<':
          return '&lt;';
        case '>':
          return '&gt;';
        case '"':
          return '&quot;';
        case "'":
          return '&#39;';
        default:
          return match;
      }
    });
  };

  // 2. 입력을 항상 배열로 정규화하여 로직을 단순화
  const tagsArray = Array.isArray(tagsInput) ? tagsInput : [tagsInput];

  const attributes = (obj) => {
    const attr = Object.entries(obj)
      .map(([key, value]) => {
        // 3. 값이 null 또는 undefined인 속성은 생성하지 않음
        if (value == null) return null;
        // 4. 속성 값을 안전하게 이스케이프 처리
        return `${key}="${escapeHtml(value)}"`;
      })
      .filter(Boolean) // null인 항목 제거
      .join(' '); // 속성들을 공백으로 연결

    return `<meta ${attr}>`;
  };

  // 배열의 각 객체를 순회하며 <meta ...> 문자열 조각으로 변환
  const metaStrings = tagsArray.map((tagObject) => attributes(tagObject));

  // 생성된 모든 <meta> 태그 문자열을 하나로 합침
  return metaStrings.join('');
};

export const getSelectedOptions = (
  optionArray = [],
  unit = ' / ',
  format = (parents, child) => child.option_name
) => {
  if (!optionArray || !optionArray.length) return '-';

  return optionArray
    .map((cur) => cur.option.map((op) => format(cur, op)).join(unit))
    .join(unit);
};
